import { createContext } from 'react';

type PageNavigationContextType = {
  id: string;
  setId: (id: string) => void;
  toggleExpand: (rowId: string) => void;
};

const PageNavigationContext = createContext<PageNavigationContextType>({
  id: '',
  setId: () => {},
  toggleExpand: (_rowId: string) => null,
});

export default PageNavigationContext;
